import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierObjection extends Layout {
    sourceCarrierObjection: DataSource;
    textboxDescr: Textbox;
    textboxId: Textbox;
    textboxResponseScript: Textbox;
}
